export class NativeStreamScalarOutputField {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamScalarOutputKind",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamScalarOutputField.attributeTypeMap;
    }
    constructor() {
    }
}
